import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl, FormattedMessage } from 'react-intl';
import * as appPropTypes from '../../../appPropTypes';
import * as chatActions from '../../../../store/actions/chatActions';
import classnames from 'classnames';
import Message from './Item/Message';
import EmptyAvatar from '../../../../images/avatar-empty.jpeg';
import Button from '@material-ui/core/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import File from '../List/Item/File';
import WebinarMessage from './Item/webinarMessage';
import GradientButton from '../../../customMui/newButton/newButton';
import { Chip } from '@material-ui/core';

const styles = (theme) =>
	({
		root :
	{
		height        : '100%',
		display       : 'flex',
		flexDirection : 'column',
		alignItems    : 'flex-End',
		overflowY     : 'auto',
		padding       : theme.spacing(1)
	},
		'@global' : {
			'*' : {
				'scrollbar-width' : 'thin'
			},
			'*::-webkit-scrollbar' : {
				width  : '5px',
				height : '5px'
			},
			'*::-webkit-scrollbar-track' : {
				background : 'white'

			},
			'*::-webkit-scrollbar-thumb' : {
				backgroundColor : '#999999'
			}
		},
		'MsgContainer' :
	{
		backgroundColor : 'red'
	},
		buttonGoToNewest :
	{
		position     : 'fixed',
		borderRadius : '50px',
		'&.show'     :
{
	transition : 'opacity 0.5s',
	opacity    : '1'
},
		'&.hide' :
{
	transition : 'opacity 0.5s',
	opacity    : '0'
},
		'&.asc' : {
			bottom : '100px'
		},
		'&.desc' : {
			top : '130px'
		}
	},
		noMsg : {
			width          : '100%',
			height         : '100%',
			display        : 'flex',
			flex           : 'none',
			flexDirection  : 'column',
			alignItems     : 'center',
			justifyContent : 'center'
		}
	});

class MessageList extends React.Component
{
	constructor(props)
	{
		super(props);

		this.refList = React.createRef();
		this.state = {
			isUserAtBottom : true // Track if the user is at the bottom of the scroll
		};
	}

	componentDidMount()
	{
		this.refList.current.addEventListener('scroll', this.handleScroll);
		this.scrollToBottom();
	}

	componentDidUpdate(prevProps)
	{
		// Check if there are new messages
		if (prevProps.chat.broadcastMessage.length !== this.props.chat.broadcastMessage.length)
		{
			// Only scroll to bottom if the user was already at the bottom before the new message
			if (this.state.isUserAtBottom)
			{
				this.scrollToBottom();
			}
		}
	}

handleScroll = () =>
{
// Check if the user is at the bottom and update state accordingly
	this.setState({
		isUserAtBottom : this.isUserAtBottom()
	});
};

isUserAtBottom = () =>
{
// Helper function to check if the user is at the bottom of the div
	const { scrollTop, scrollHeight, clientHeight } = this.refList.current;

	return Math.abs(scrollHeight - scrollTop - clientHeight) < 1;
};

scrollToBottom = () =>
{
	if (this.refList.current)
	{
		this.refList.current.scrollTop = this.refList.current.scrollHeight;
	}
};

render()
{
	const {
		peerId,
		chat,
		myPicture,
		classes,
		me,
		peers,
		intl,
		files,
		isPlaying,
		webinarUser,
		setIsPlaying,
		webinarData, replyData, setReplyData, preview, setPreview, setFileUrl, fileUrl
	} = this.props;

	let items = [ ...chat.broadcastMessage ];

	if (webinarUser)
	{
		// Filter items where userId equals peerId (for host visibility)
		items = items.filter((item) => item.userId === window.btoa(me.email) || item.replyTo === window.btoa(me.email) || (item.sender==='Host' && !item.replyTo) || (item.sender==='Guest' && item.chatVisibility === 'attendees'));
	}
	// else if (webinarData.chatVisibility === 'panelists')
	// {
	// 	// Filter items where userId or receiver equals peerId (for panelist visibility)
	// 	items = items.filter((item) => item.userId === me.uid);
	// }

	// items.sort((a, b) => (a.time < b.time ? -1 : 1));
	items.sort((a, b) => new Date(a.sendTime) - new Date(b.sendTime));

	if (items.length > 0)
	{
		if (chat.order === 'asc') items.sort();
		else if (chat.order === 'desc') items.reverse();
	}

	return (
		<React.Fragment>
			<div id='chatList' className={classes.root} ref={this.refList}>
				{/* Button to scroll to the newest message */}
				<GradientButton
					variant='contained'
					color='primary'
					size='small'
					onClick={() => this.scrollToBottom()}
					className={classnames(classes.buttonGoToNewest, 'hide', chat.order === 'asc' ? 'asc' : 'desc')}
					endIcon={
						chat.order === 'asc' ? (
							<ChevronLeftIcon style={{ color: 'white', transform: 'rotate(270deg)' }} />
						) : (
							<ChevronLeftIcon style={{ color: 'white', transform: 'rotate(90deg)' }} />
						)
					}
				>
					({chat.countUnread})&nbsp;
					<FormattedMessage id='label.chatNewMessages' defaultMessage='New messages' />
				</GradientButton>

				{items.length === 0 ? (
					<div className={classes.noMsg}>
						<img src='icons/noMsg.svg' alt='noMsg' />
						<span className='lHdng pdngTSM'>
							{intl.formatMessage({
								id             : 'label.chatNoMessages',
								defaultMessage : 'No messages'
							})}
						</span>
					</div>
				) : (
					items.map((item, index) =>
					{
						if (item.message)
						{
							return (
								<WebinarMessage
									key={item.sendTime}
									peerId={item.userId}
									sendTime={item.sendTime}
									avatar={(item.userName === 'response' ? item.picture : myPicture) || ''}
									userName={item.userName}
									message={item.message}
									sender={item.sender}
									webinarUser={item.webinarUser}
									isseen={item.isRead}
									item={item}
									setReplyData={setReplyData}
								/>
							);
						}
						else if (item.type === 'file')
						{
							let filePicture;

							if (me.id === item.peerId)
							{
								filePicture = me.picture;
							}
							else if (peers[item.peerId])
							{
								filePicture = peers[item.peerId].picture;
							}

							return (
								<File
									refMessage={(el) => el && this.setWidth(el)}
									key={item.key}
									time={item.createdAt || item.sendTime}
									url={item.url}
									name={item.userName}
									avatar={filePicture || ''}
									isseen={item.isRead}
									sender={me.id === item.userId ? 'Host' : item.sender}
									peerId={item.userId}
									self={item.sender === 'Host'}
									fileType={item.fileType}
									fileName={item.fileName}
									size={item.size}
									webinarUser={item.webinarUser}
									index={index}
									item={item}
									setReplyData={setReplyData}
									isPlaying={isPlaying}
									setIsPlaying={setIsPlaying}
									prew={preview} setPrew={setPreview}
									fileUrl={fileUrl} setFileUrl={setFileUrl}
								/>
							);
						}

						return 0;
					})
				)}
			</div>
			{replyData && <div className='flexRow pdngXS aCntr gap8'>
				<small>Reply to</small>
				<Chip label={`${replyData?.userName}`} color='primary' size='small' onDelete={() => setReplyData(null)} />
			</div>}
		</React.Fragment>
	);
}
}

MessageList.propTypes =
{
	chat      : PropTypes.any,
	myPicture : PropTypes.string,
	classes   : PropTypes.object.isRequired,

	files                   : PropTypes.any,
	me                      : appPropTypes.Me.isRequired,
	peers                   : PropTypes.object.isRequired,
	intl                    : PropTypes.object.isRequired,
	setIsBroadcastScrollEnd : PropTypes.func.isRequired,
	setIsBroadcastMsgRead   : PropTypes.func.isRequired,
	peerId                  : PropTypes.string.isRequired,
	isPlaying               : PropTypes.any,
	webinarUser             : PropTypes.any,
	setIsPlaying            : PropTypes.any,
	webinarData        	    : PropTypes.any,
	replyData               : PropTypes.any,
	setReplyData            : PropTypes.any,
	preview                 : PropTypes.any,
	setPreview              : PropTypes.any,
	fileUrl                 : PropTypes.any,
	setFileUrl              : PropTypes.any
};

const mapStateToProps = (state) =>
	({
		chat        : state.chat,
		myPicture   : state.me.picture,
		me          : state.me,
		peers       : state.peers,
		files       : state.files,
		webinarData : state.webinar.webinarData,
		peerId      : state.me.id
	});

const mapDispatchToProps = (dispatch) =>
	({
		setIsBroadcastScrollEnd : (flag) =>
		{
			dispatch(chatActions.setIsBroadcastScrollEnd(flag));
		},
		setIsBroadcastMsgRead : (id, isRead) =>
		{
			dispatch(chatActions.setIsBroadcastMsgRead(id, isRead));
		}
	});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.chat === next.chat &&
	prev.files === next.files &&
	prev.me.picture === next.me.picture &&
	prev.me === next.me &&
	prev.peers === next.peers
			);
		}
	}
)(withStyles(styles)(injectIntl(MessageList)));